<template>
		<div class="p-4">
			<Steps :currentStep="3"></Steps>
		</div>
		<Resume></Resume>
</template>

<script>
import Resume from '../../Widgets/Contracts/RenewContract/Resume/Resume.vue';
import Steps from '../../Widgets/Contracts/RenewContract/Steps/Steps.vue';
export default {
  name: 'RenewContractStep2',
  components: {
    Resume,
    Steps,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>